import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function DashboardCard({
	className,
	children,
	...props
}: { className?: string; children: ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div className={cn("surface-panel", className)} {...props}>
			{children}
		</div>
	);
}

export function DashboardCardHeader({
	className,
	children,
}: {
	className?: string;
	children: ReactNode;
}) {
	return <div className={cn("panel-heading", className)}>{children}</div>;
}

export function DashboardCardTitle({ children }: { children: ReactNode }) {
	return <h3 className="type-section-title text-foreground">{children}</h3>;
}

export function DashboardCardBody({
	className,
	children,
}: {
	className?: string;
	children: ReactNode;
}) {
	return <div className={cn("panel-body", className)}>{children}</div>;
}
